<template>
  <div class="main-options-list">
    <div class="options-list-actions">
      <v-btn tile color="success" @click="onAddEmpty">
        <v-icon left> mdi-plus </v-icon>
        {{ $t("components.invest.optionsList.addBtn") }}
      </v-btn>
    </div>
    <div class="options-list-container">
      <draggable v-model="options" handle=".dragHandler" ghost-class="ghost">
        <!-- <transition-group> -->
        <div v-for="(option, ind) in options" :key="ind">
          <div class="options-list-item">
            <div
              class="dragHandler"
              :title="$t('components.invest.optionsList.moved')"
            >
              <v-icon large>mdi-drag-vertical</v-icon>
            </div>
            <div>
              <v-text-field
                v-model="option.key"
                :label="$t('components.invest.optionsList.key')"
                hide-details
                clearable
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                v-model="option.value"
                :label="$t('components.invest.optionsList.value')"
                clearable
                hide-details
              ></v-text-field>
            </div>
            <div class="options-actions-panel">
              <v-btn
                class="mx-2"
                fab
                dark
                x-small
                color="red"
                rounded
                :title="$t('components.invest.optionsList.delete')"
                @click="onRemoveItem(ind)"
              >
                <v-icon dark>
                  mdi-minus
                </v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <!-- </transition-group> -->
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "OptionsList",
  components: { draggable },
  model: {
    prop: "items",
    event: "change",
  },
  data: () => ({
    options: [
      {
        name: "one",
        fixed: false,
      },
    ],
  }),
  props: {
    items: {
      type: Array,
      default: null,
    },
  },
  computed: {},

  methods: {
    onChangeItems() {
      this.$emit("change", this.items);
    },

    onRemoveItem(ind) {
      this.options.splice(ind, 1);
    },
    onAddEmpty() {
      if (!this.options) this.options = [];
      this.options.push({ key: "", value: "" }); //({ key: `aaa ${this.options.length}`, value: "bbb" });
    },
  },
  mounted() {
    this.options = this.items;
  },

  watch: {
    options(val) {
      //  console.log("WWWWWW", val);
      this.$emit("change", val);
    },
    items(val) {
      //this.$set("options", val);
      this.options = val;
      // console.log("items", val);
    },
  },
};
</script>
<style lang="scss">
.main-options-list {
  .ghost {
    opacity: 0.3;
  }

  .options-list-actions {
    margin-bottom: 10px;
  }
  .options-list-container {
    .options-list-item {
      display: flex;
      margin-bottom: 4px;
      > div {
        padding: 5px;
        border-bottom: 1px solid #dedede;
      }
      .dragHandler {
        width: 20px;
        background: #efefef;
        cursor: grabbing;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .options-actions-panel {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
